import React, { useState, useEffect } from "react";
import apiService from "./services/api.service";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { selectCartCount, selectCartItems } from "./Redux/shoppingCartReducer";
import "./i18n/config";
import i18next from "i18next";
import { Row, Col, Spinner } from "react-bootstrap";
import ProductsListComponent from "./ProductsList";
import Modal from 'react-modal';
import { Alert } from "bootstrap";
import { setUser } from "./Redux/userReducer";
import { eventService } from "./services/event.service";

function PersonalDetailsFormComponent({ register, handleSubmit, errors, setValue, loading, setLoading, sendToGifteeTime, ...props }) {
  const [lang, setLang] = useState("");

  const [clubconditionsChecked, setClubconditionsChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [modalTermsIsOpen, setModalTermsIsOpen] = useState(false);
  const [modalPrivacyIsOpen, setModalPrivacyIsOpen] = useState(false);
  const [termsText, setTermsText] = useState("");
  const [privacyText, setPrivacyText] = useState("");
  const [isCheckedUser, setIsCheckedUser] = useState(false);
  const [isShowVrifyField, setISshowVrifyField] = useState(false);
  const [smsMsg, setSmsMsg] = useState("");
  const [paybyOtherChecked, setPaybyOtherChecked] = useState(false);


  const [customerPhone, setCustomerPhone] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerPassport, setCustomerPassport] = useState("");


  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  let cartItems = useSelector(selectCartItems);

  const productsFromSession = window.sessionStorage.getItem("products");
  cartItems = productsFromSession ? JSON.parse(productsFromSession) : cartItems;
  const loggedUser = useSelector((state) => state.user.user)
  const chainId = new URLSearchParams(location.search).get("chainid") || 0;

  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };

  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");
    getChainTerms();
    findLoggedUser();
  }, []);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);

  const getChainTerms = () => {
    let privacyText = null;
    let termsText = null;

    apiService.getChains(chainId)
      .then(response => {
        if (response.data && response.data.data && !response.data.data[0].errors) {

          const res = response.data.data[0];
          if (res && res.translations) {
            const translation = res.translations.find(t => t.languageIsoCode == new URLSearchParams(location.search).get("lang") || "eng");
            if (translation && translation.termsAndConditions) {
              termsText = translation.termsAndConditions;
            }
            if (translation && translation.privacyPolicy) {
              privacyText = translation.privacyPolicy;
            }
          }
        }
        if (!privacyText) {
          getDefaultTerms("privacy")
        }else{
          setPrivacyText(privacyText);
        }
        if (!termsText) {
          getDefaultTerms("terms")
        }else{
          setTermsText(termsText);
        }
      })
      .catch(error => {
        getDefaultTerms("terms")
        getDefaultTerms("privacy")
      });
  }

  const submitForm = (data) => {
    let valid = true;
    let errorMsg = "";


    if (!valid) {
      errorMsg = t("CheckAllFields");
      alert(errorMsg);
    } else {
      if (!clubconditionsChecked) {
        setErrorMessage(t("mustAgreeToTerms"));
      } else {
        if (!isCheckedUser) {
          checkCustomer(data.EmailInput, data);

        }
        else {

          if (isShowVrifyField) {
            checkVerificationCode(data.EmailInput, data.VerifCodeInput);
          }
          else {
            registerUser(data);
          }
        }
      }
    }
  }

  const registerUser = (data) => {
    let myCustomer = {
      customerId: null,
      customerFirstName: data.fullNameInput.substring(
        0,
        data.fullNameInput.indexOf(" ")
      ),
      customerLastName: data.fullNameInput.substring(
        data.fullNameInput.indexOf(" ") + 1
      ),
      customerIdentification: data.PassportInput ? data.PassportInput : "",
      customerEmail: data.EmailInput,
      customerPhone: data.PhoneInput,
      customerCountry: "",
      customerCity: "",
      customerAddress: "",
      customerPostalCode: "",
      customerLanguageIsoCode: lang
    };


    let gifteeDtls = {};

    if (data.GiftfullNameInput && data.GiftfullNameInput.length > 1) {


      gifteeDtls =
      {
        GiftfullNameInput: data.GiftfullNameInput,
        GiftEmailInput: data.GiftEmailInput,
        GiftFreeTextInput: data.GiftFreeTextInput,
        GiftSenderfullNameInput: data.GiftSenderfullNameInput,
        GifteePhoneInput: data.GifteePhoneInput,

      }
    }

    let errmsg = "";
    if (data.GiftfullNameInput && data.GiftfullNameInput.length > 1 && !data.GiftEmailInput && !data.GifteePhoneInput) {
      errmsg = "נא למלא אימייל ו/או טלפון נייד של מקבל המתנה";
      setErrorMessage(errmsg);
      alert(errmsg);

    }
    else {
      setErrorMessage("");
      apiService.getCustomer(data.EmailInput).then(
        (response) => {

          if (response.data.data && response.data.data.length > 0) {
            var custId = response.data.data[response.data.data.length - 1].customerId;
            myCustomer.customerId = custId;
          }


          continueOrderProc(myCustomer, gifteeDtls, data.payerNameInput ? data.payerNameInput : "", data.payerCompIDInput ? data.payerCompIDInput : "");

        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          continueOrderProc(myCustomer, gifteeDtls, data.payerNameInput ? data.payerNameInput : "", data.payerCompIDInput ? data.payerCompIDInput : "");
        }
      );

    }




  }

  const continueOrderProc = (myCustomer, myGifteeDtls, payerName, payerCompID) => {
    let products = cartItems;
    if (clubconditionsChecked) {
      const chainId = new URLSearchParams(location.search).get("chainid") || 0;
      if (Object.keys(products).length > 0) {

        let customerIp = "";
        let customerBrowserAgent = navigator.userAgent;

        setLoading(true);
        apiService.getUserIp().then(
          (response) => {
            customerIp = response;
          },
          (error) => {

          }
        )
          .finally(
            () => {
              setOrderAfterAllChecks(chainId, products, myCustomer, myGifteeDtls, customerIp, customerBrowserAgent, payerName, payerCompID)
            }
          );

      }
    }
    else {
      setErrorMessage(t("mustAgreeToTerms"));
    }


  };


  const setOrderAfterAllChecks = (chainId, products, myCustomer, myGifteeDtls, customerIp, customerBrowserAgent, payerName, payerCompID) => {

    // check if the product still available before payment
    const currentItem = Object.keys(cartItems)[0];
    const currentProduct = products[currentItem].selectedProduct;
    const blockingIdentifier = sessionStorage.getItem("productBlockingIdentifier") || null;

    if(blockingIdentifier && currentProduct?.productId){

      setLoading(true);
      apiService.getBlockedProduct(currentProduct.productId, blockingIdentifier)
      .then(response => {

        if (!response.errors && response.data && response.data.data) {
          if (response.data.data[0].isValid) {
            let gifteeMsg = myGifteeDtls && myGifteeDtls.GiftFreeTextInput && myGifteeDtls.GiftFreeTextInput.length > 0 ? myGifteeDtls.GiftFreeTextInput + " </br>" + t("sentFrom") + myGifteeDtls.GiftSenderfullNameInput : "";
            apiService
              .setOrder(chainId, products, myCustomer, myGifteeDtls, lang, customerIp, customerBrowserAgent, gifteeMsg, payerName, payerCompID, 2, sendToGifteeTime , blockingIdentifier)
              .then((res) => {
                if (res) {
                  props.onInsertCartInProgressComplete();
                  eventService.beginCheckout();
                }
                else {
                  alert(t("setOrderError"));
                }
              })
              .catch((err) => {
                console.error(err);
              })
              .catch(() => {})
          }
          else {
            alert(t("productNotAvailableAnymore"));
          }
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
    }
  }

  const clubconditionsCheckChanges = (isChecked) => {
    setClubconditionsChecked(isChecked);
    setErrorMessage("");
  };


  const getDefaultTerms = (paramtoRead) => {

    apiService.getGlobalParameters(paramtoRead).then(
      (response) => {

        if (response.data && response.data.data && response.data.data.length > 0) {
          let termstext = getChainTermsTranslations(response.data.data[0]);
          termstext = termstext && termstext.globalParameterValue ? termstext.globalParameterValue : response.data.data[0].globalParameterValue;
          if (paramtoRead === "terms") {
            setTermsText(termstext)
          }
          if (paramtoRead === "privacy") {
            setPrivacyText(termstext)
          }

        }

      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );

  };

  const getChainTermsTranslations = (objectToTranslate) => {
    if (objectToTranslate && objectToTranslate.translations) {
      let ObjectTranslations = objectToTranslate.translations.filter((p) => {
        return p.languageIsoCode == lang || p.languageIsoCode == new URLSearchParams(location.search).get("lang");
      });
      return ObjectTranslations.length > 0 ? ObjectTranslations[0] : {};
    }
    return {};
  };


  const checkCustomer = (myEmail, data) => {
    setLoading(true)
    apiService
      .sendIdentityVerificationSms(myEmail, productsFromSession[0].propertyId ? productsFromSession[0].propertyId : 0, new URLSearchParams(location.search).get("chainid") || 0)
      .then((res) => {
        if (res.Success === true) {
          setIsCheckedUser(true);
          setISshowVrifyField(true);
          setSmsMsg(t("smsWasSent") + " <div class='phonenum'>" + res.MaskedPhoneNumber + "</div>");

        }
        else {
          apiService.getCustomer(myEmail).then(
            (response) => {

              if (response.data.data && response.data.data.length > 0) {
                var custId = response.data.data[response.data.data.length - 1].customerId;
                if (custId > 0) {
                  setSmsMsg(t("cantSendSmsToExistimCustomer"))
                }
                else {
                  setIsCheckedUser(true);
                  registerUser(data);
                }
              }
              else {
                setIsCheckedUser(true);
                registerUser(data);
              }
            },
            (error) => {
              const _content =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
        }
      })
      .catch((err) => {
        console.error(err);
        setSmsMsg(t("verificationError"))
      })
      .finally(() => setLoading(false));
  };


  const checkVerificationCode = (Email, VerificationCode) => {
    setLoading(true);

    apiService
      .verifyIdentityBySms(Email, VerificationCode)
      .then((res) => {
        if (res.customerEmail == Email) {
          setIsCheckedUser(true);
          setISshowVrifyField(false);
          setCustomerName(res.customerFirstName + " " + res.customerLastName);
          setCustomerPhone(res.customerPhone);
          setCustomerPassport(res.customerIdentification);

          setValue("fullNameInput", res.customerFirstName + " " + res.customerLastName, { shouldDirty: true });
          setValue("PhoneInput", res.customerPhone, { shouldDirty: true });
          setValue("PassportInput", res.customerIdentification, { shouldDirty: true });

          let loggedUser =
          {
            id: res.customerId,
            email: res.customerEmail

          }
          dispatch(setUser(loggedUser))

          setSmsMsg(t("successfullVerification"));
          setTimeout(() => {
            setSmsMsg("");
          }, 3000);
        }
        else {
          setSmsMsg(t("failedVerification"))
        }
      })
      .catch((err) => {
        console.error(err);
        setSmsMsg(t("verificationError"))
      })
      .finally(() => setLoading(false));
  };


  const findLoggedUser = () => {


    if (loggedUser) {

      apiService.getCustomer(loggedUser.email).then(
        (response) => {

          if (response.data.data && response.data.data.length > 0) {
            var custId = response.data.data[response.data.data.length - 1].customerId;
            let user = response.data.data[response.data.data.length - 1];
            if (custId != loggedUser.id) {
              logout();
            }
            else {
              setIsCheckedUser(true);

              setValue("EmailInput", user.customerEmail, { shouldDirty: true });
              setValue("fullNameInput", user.customerFirstName + " " + user.customerLastName, { shouldDirty: true });
              setValue("PhoneInput", user.customerPhone, { shouldDirty: true });
              setValue("PassportInput", user.customerIdentification, { shouldDirty: true });
              setCustomerName(user.customerFirstName + " " + user.customerLastName);
              setCustomerPhone(user.customerPhone);
              setCustomerPassport(user.customerIdentification);
            }

          }
          else {
            logout();
          }
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );

    }
    else {
      logout();
    }

  }


  const logout = () => {

  }

  const passportValidation = (value) => {
    let id = String(value).trim();
    if (id.length > 9 || id.length < 5 || isNaN(id)) {
      return t("invalidPassport");
    }

    // Pad string with zeros up to 9 digits
    id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
    const isIdStructureValid = (Array
      .from(id, Number)
      .reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
      }) % 10 === 0);
    if (!isIdStructureValid) {
      return t("invalidPassport");
    }

    return true;
  }


  const PaybyOtherCheckChanged = (isChecked) => {
    setPaybyOtherChecked(isChecked);
    if (isChecked) {

    }


  };

  return (
    <>
      <form onSubmit={handleSubmit((data) => submitForm(data))}>
        <div className="personal-details-form-wrap">
          <Row className={!smsMsg ? "hidden" : "conf-msg"}>
            <Col dangerouslySetInnerHTML={{ __html: smsMsg }} >
            </Col>
          </Row>
          <Row>
            <Col>
              <label htmlFor="EmailInput"> {t("Email")}</label>
              <input type="email"
                id="EmailInput"
                name="EmailInput"
                {...register("EmailInput", {
                  required: t("Required"),
                  pattern: {
                    value: new RegExp(t("EmailRegex")),
                    message: t("EmailRegexMsg"),
                  },
                })}
                disabled={isCheckedUser ? 'disabled' : ''}
              />
              <span role="alert" className="error">{errors.EmailInput?.message}</span>
            </Col>
          </Row>

          {isShowVrifyField && <Row>
            <Col>
              <label htmlFor="VerifCodeInput"> {t("VerificationCode")}</label>
              <input
                id="VerifCodeInput"
                type="text"
                name="VerifCodeInput"
                {...register("VerifCodeInput", {
                  required: t("Required"),

                })}

              />
              <span role="alert" className="error">{errors.VerifCodeInput?.message}</span>
            </Col>
          </Row>}

          {isShowVrifyField ? <Row>
            <Col>
              <input
                aria-label={t("confirmVerfCode")}
                type="submit"
                className="btn"
                value={t("confirmVerfCode")}

              />
            </Col>
          </Row> : null}

          <div className={isShowVrifyField ? "hidden" : ""}>


            <Row>
              <Col>
                <label htmlFor="fullNameInput"> {t("FullName")}</label>
                <input
                  id="fullNameInput"
                  type="text"
                  name="fullNameInput"
                  {...register("fullNameInput", {
                    required: !isShowVrifyField ? t("Required") : false,
                    pattern: {
                      value: new RegExp(t("FullNameRegex")),
                      message: t("FullNameRegexMsg"),
                    },
                  })}
                  disabled={customerName !== "" ? 'disabled' : ''}
                />
                <span role="alert" className="error">{errors.fullNameInput?.message}</span>
              </Col>
            </Row>

            <Row>
              <Col>
                <label htmlFor="PhoneInput"> {t("Phone")} <br /> {customerPhone === "" && <span className="phone-comment">* {t("PhoneComment")}</span>}</label>
                <input
                  name="PhoneInput"
                  type="tel"
                  id="PhoneInput"
                  {...register("PhoneInput", {
                    required: !isShowVrifyField ? t("Required") : false,
                    pattern: {
                      value: new RegExp(t("PhoneRegex")),
                      message: t("PhoneRegexMsg"),
                    },
                  })}
                  disabled={customerPhone != "" ? 'disabled' : ''}
                />
                <span role="alert" className="error">{errors.PhoneInput?.message}</span>
              </Col>
            </Row>

            <Row>
              <Col>
                <label htmlFor="PassportInput"> {t("Passport")}</label>
                <input
                  type="tel"
                  id="PassportInput"
                  name="PassportInput"
                  {...register("PassportInput", {
                    required: isCheckedUser && !isShowVrifyField ? t("Required") : false,
                    validate: !isShowVrifyField ? {
                      validateID: passportValidation
                    } : null
                  })}
                  disabled={customerPassport != "" ? 'disabled' : ''}
                />
                <span role="alert" className="error">{errors.PassportInput?.message}</span>
              </Col>
            </Row>
            <div className="payByOtherWrap">
              <div className="payByOther"> <input aria-label={t("payByOther")} type="checkbox" className="checkbox" value={paybyOtherChecked} onChange={e => PaybyOtherCheckChanged(!paybyOtherChecked)} />
                <span>{t("payByOther")}</span>
              </div>
              {paybyOtherChecked &&
                <>
                  <Row>
                    <Col>
                      <label htmlFor="payerNameInput"> {t("PayerName")}</label>
                      <input
                        id="payerNameInput"
                        type="text"
                        name="payerNameInput"
                        {...register("payerNameInput", {
                          required: paybyOtherChecked ? t("Required") : false,
                          minLength: 2,
                        })}

                      />
                      <span role="alert" className="error">{errors.payerNameInput?.message}</span>
                      {errors.payerNameInput && errors.payerNameInput.type === "minLength" && (
                        <span role="alert" className="error">{t("AtLeast2Chars")}</span>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label htmlFor="payerCompIDInput"> {t("payerCompID")}</label>
                      <input
                        id="payerCompIDInput"
                        type="text"
                        name="payerCompIDInput"
                        {...register("payerCompIDInput", {
                          required: paybyOtherChecked ? t("Required") : false,
                          pattern: {
                            value: new RegExp(t("numbersRegex")),
                            message: t("numbersRegexMsg"),
                          },
                          minLength: 6,
                        })}

                      />
                      <span role="alert" className="error">{errors.payerCompIDInput?.message}</span>
                      {errors.payerCompIDInput && errors.payerCompIDInput.type === "minLength" && (
                        <span role="alert" className="error">{t("AtLeast6Numbers")}</span>
                      )}
                    </Col>
                  </Row>
                </>
              }

            </div>

            <Row>
              <Col className="checkboxWrap">
                <input aria-label={(t("readTerms")) + (t("SiteTerms")) + (t('andAlso')) + (t("SitePrivacy"))} type="checkbox" className="checkbox" value={clubconditionsChecked} onChange={e => clubconditionsCheckChanges(!clubconditionsChecked)} />
                <div>
                  <span>{t("readTerms")}</span>
                  <span
                    title={t("readTerms")}
                    onClick={e => setModalTermsIsOpen(true)}
                    className="terms-link"
                    dangerouslySetInnerHTML={{ __html: t("SiteTerms") }}></span>
                  <br />
                  <span >{t('andAlso')}</span>
                  <span
                    title={t("SitePrivacy")}
                    onClick={e => setModalPrivacyIsOpen(true)}
                    className="terms-link pe-1"
                    dangerouslySetInnerHTML={{ __html: t("SitePrivacy") }}>
                  </span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="error">
                {errorMessage && errorMessage.length > 1 ? errorMessage : null}
              </Col>
            </Row>
            <Row>
              <Col>
                <Col sm={12} className="book-btn text-start"><button className="btn long-button" type="submit" disabled={loading}>{loading && <Spinner className="spinner" animation="border" />} {t("ContinueToPayment")}</button></Col>

                {/* <input
                  type="submit"
                  className="btn"
                  value={t("ContinueToPayment")}
                /> */}
              </Col>
            </Row>
          </div>

        </div>
      </form>

      <Modal
        isOpen={modalTermsIsOpen}
        contentLabel={t("AgreeToTermsEnd")}
        className='terms-modal'  >
        <div className="modal-header">
          <button type="button" className="close" aria-label={t("close")} onClick={e => setModalTermsIsOpen(false)}><span aria-hidden="true">×</span></button>
          <h4 className="modal-title" aria-label={t("TermsTitle")}>{t("TermsTitle")}</h4>
        </div>
        <div className="modal-body" dangerouslySetInnerHTML={{ __html: termsText }}>

        </div>
      </Modal>

      <Modal
        isOpen={modalPrivacyIsOpen}
        contentLabel={t("AgreeToTermsEnd")}
        className='terms-modal'  >
        <div className="modal-header">
          <button type="button" className="close" onClick={e => setModalPrivacyIsOpen(false)}><span aria-hidden="true">×</span></button>
          <h4 className="modal-title">{t("PrivacyTitle")}</h4>
        </div>
        <div className="modal-body" dangerouslySetInnerHTML={{ __html: privacyText }}>

        </div>
      </Modal>
    </>

  );
}

export default PersonalDetailsFormComponent;
